"use client";
import { getDateWithDayLong, getTime } from "@/helpers/dateHelper";
import { SmaListItem } from "@/sources/kicker-amateur/types";
import { useHasServiceConsent, useIsInitialized } from '@s-group/react-usercentrics'
import { SocialMediaFacebookElement } from "./SocialMediaFacebookElement";

type NewsElementProps = {
  item: SmaListItem;
  className?: string;
};

export function SocialMediaElement({ item, className }: NewsElementProps) {
  const isFacebookConsentGiven = useHasServiceConsent('caGWhvFkc')
  const idConsentInitialized = useIsInitialized()

  return (
    <div className={`${className}`}>
      <div className="">
        <div className="outer-social">
          {item.type == "facebook" && item.post_url && item.id && (
            <SocialMediaFacebookElement id={item.id} url={item.post_url} isConsentGiven={isFacebookConsentGiven == true} idConsentInitialized={idConsentInitialized}/>
          )}
        </div>
      </div>
      {item.post_time && (
        <div className="flex justify-between items-baseline pt-2">
          <time
            className="text-muted"
            dateTime={new Date(item.post_time).toISOString()}
          >
            {getDateWithDayLong(item.post_time)}, {getTime(item.post_time)}
          </time>
          <div className="flex-grow hidden @md:block w-0"></div>
        </div>
      )}
    </div>
  );
}
